import { RouteObject } from 'react-router-dom';

import TechChecks from '../TechChecks';

export const TECH_CHECKS_PATH = '/tech-checks';

export const TechChecksRoutes: RouteObject[] = [
  {
    path: '',
    element: <TechChecks />,
  },
];
